import { LocaleCode } from '../types/LocaleCode';
export const getLocale = (locale, defaultValue = LocaleCode.en_US) => {
    var _a;
    return ((_a = Object.entries(LocaleCode).find(([key, value]) => key === locale || value === locale)) === null || _a === void 0 ? void 0 : _a[1]) || defaultValue;
};
const textToKeyMap = {
    'Policy Number': 'POLICY_NUMBER',
    'Invoice Number': 'INVOICE_NUMBER',
};
export const textToLocaleKey = (text) => {
    return textToKeyMap[text] || text;
};
export const translations = {
    [LocaleCode.en_US]: {
        MERCHANT_ACCOUNT_REGISTRATION: 'Merchant Account Registration',
        FILL_OUT_FORM: 'Please fill out the form below.',
        // mrs - consolidate - dup
        // FIRST_NAME: 'First name',
        // LAST_NAME: 'Last name',
        ACCOUNT_NICKNAME: 'Account name',
        ACCOUNT_NICKNAME_TOOLTIP: 'This is to identify your account.',
        LEGAL_BUSINESS_NAME: 'Legal business name',
        LEGAL_ENTITY: 'Legal entity',
        PHONE: 'Phone number',
        // mrs - consolidate - dup
        // EMAIL: 'Email address',
        WEBSITE: 'Website',
        JOB_TITLE: 'Job title',
        SHAREHOLDER_TYPE: 'Shareholder Type',
        NEED_THE_FOLLOWING: 'To complete registration, you will need the following:',
        NEED_IMAGE_OF_ID: "Image of a government issued form of identification, such as your driver's license or passport.",
        NEED_OWNER_INFO: 'SSN & Date of Birth of all individuals who directly or indirectly own 25% or more of the company.',
        NEED_BANK_INFO: 'Bank account information for settlement of funds. Federal Tax ID (EIN/TIN).',
        START_WITH_BASIC_INFO: `Let's start with some basic information:`,
        PROCESSING_YOUR_APPLICATION: 'Processing your application...',
        MAY_TAKE_A_MINUTE: 'This may take up to a minute to complete.',
        SUCCESS: 'Success!',
        ONBOARDING_SUCCESS: 'Your application is complete and must be approved before you may begin processing. You may login to the portal to check the status of your application.',
        BEING_REDIRECTED: 'You are being redirected...',
        GO_TO_LOGIN: 'Go to Portal',
        CANCEL: 'Cancel',
        CONTINUE: 'Continue',
        OK: 'Ok',
        ERROR: 'Error',
        ERROR_REGISTERING: 'There was an error trying to register your account.',
        ERROR_UNKNOWN_TENANT: 'Unknown tenant',
        ERROR_FIRST_NAME_REQUIRED: 'First name is required',
        ERROR_LAST_NAME_REQUIRED: 'Last name is required',
        ERROR_PHONE_REQUIRED: 'Phone is required',
        ERROR_PHONE_INVALID: 'Phone is invalid',
        ERROR_URL_REQUIRED: 'Website is required',
        ERROR_URL_INVALID: 'Website is invalid',
        ERROR_EMAIL_REQUIRED: 'Email is required',
        ERROR_EMAIL_INVALID: 'Email is invalid',
        ERROR_NICKNAME_REQUIRED: 'Account nickname is required',
        ERROR_NICKNAME_INVALID: 'Account nickname is too long',
        ERROR_LEGAL_BUSINESS_NAME_REQUIRED: 'Legal business name is required',
        ERROR_LEGAL_ENTITY_REQUIRED: 'Legal entity is required',
        ERROR_SHAREHOLDER_REQUIRED: 'Shareholder is required',
        ERROR_JOB_TITLE_REQUIRED: 'Job title is required',
        ERROR_COUNTRY_CODE_REQUIRED: 'Country is required',
        ERROR_COUNTRY_CODE_INVALID: 'Country is invalid',
        ERROR_LOCALE_CODE_REQUIRED: 'Locale is required',
        ERROR_LOCALE_CODE_INVALID: 'Locale is invalid',
        ERROR_NAME_REQUIRED: 'Name is required',
        ERROR_ACCOUNT_NUMBER_REQUIRED: 'Account number is required',
        ERROR_PHONE_NUMBER_REQUIRED: 'Phone number is required',
        ERROR_POSTAL_CODE_REQUIRED: 'Postal code is required',
        TERMS_AND_CONDITIONS: 'Terms and Conditions',
        AGREE: 'I agree to the $t(TERMS_AND_CONDITIONS)',
        COPYRIGHT: 'Copyright',
        INDIVIDUAL: 'Individual',
        BUSINESS: 'Business',
        NON_PROFIT: 'Non-Profit',
        PARTNERSHIP: 'Partnership',
        PUBLIC_COMPANY: 'Public Company',
        OWNER: 'Owner',
        CONTROLLER: 'Controller',
        SIGNATORY: 'Signatory',
        THANK_YOU: 'Thank You!',
        ONBOARDING_RETURN_MESSAGE: 'You may log into the Portal to resume or check the status of your registration. You may begin processing when your merchant account has been approved.',
        THANKS_FOR_SETTING_UP: 'Thank you for setting up a merchant account with AppliedPay.',
        BY_SIGNING_UP: 'By signing up for AppliedPay, you agree to the following:',
        AGREE_RATES: 'Processing rates of 3.5% for Credit Card Payments and $4.00 per ACH Transaction.',
        AGREE_NO_LIFE: 'You will not accept payments for Life Insurance Policies.',
        AGREE_LAW: 'Please follow all state, local and/or regulatory requirements for the handling of insurance payments and the appropriate trust accounting.',
        MUST_REQUEST_ACCESS: 'You are receiving this message because you have not been setup as a user to access the agency portal. Please fill out the form below to request access from your administrator.',
        REQUEST_ACCESS: 'Request Access',
        FAILED_TO_REQUEST_ACCESS: 'Failed to Request Access',
        ERROR_REQUESTING_ACCESS: "There was an error requesting access to the Portal. Perhaps you've already requested access.",
        YOU_WILL_BE_NOTIFIED_ONCE_APPROVED: 'You will be notified via email when your account has been approved.',
        COUNTRY: 'Country',
        LOCALE: 'Locale',
        LANGUAGE: 'Language',
        COUNTRY_UNITED_STATES: 'United States',
        COUNTRY_CANADA: 'Canada',
        COUNTRY_UNITED_KINGDOM: 'United Kingdom',
        LANGUAGE_ENGLISH: 'English',
        LANGUAGE_FRENCH: 'French',
        IMAGE_UPLOADED: 'Image has successfully been uploaded. Please save your changes.',
        IMAGE_UPLOAD_FAILED: 'Upload failed. Please verify required file types and file size',
        UPLOAD: 'Upload',
        FILE_SIZE_LIMIT: 'There is a file size limit of 2MB. File types accepted: png, bmp & jpg.',
        PRIMARY_COLOR: 'Primary Color',
        PRIMARY_TEXT_COLOR: 'Primary Text Color',
        ERROR_PRIMARY_COLOR_REQUIRED: 'Primary color is required',
        ERROR_PRIMARY_TEXT_COLOR_REQUIRED: 'Primary text color is required',
        PAYMENT_METHOD: 'Payment Method',
        TRANSACTIONS_COUNT: 'Transactions Count',
        TRANSACTIONS: 'Transactions',
        STATEMENTS: 'Statements',
        AGENCY_SETTINGS: 'Agency Settings',
        AGENCY_INFO_AND_BRANDING: 'Agency Information & Branding',
        LOADING: 'Loading',
        MAKE_A_PAYMENT: 'Make a Payment',
        ENTER_PAYMENT_INFO: 'Enter your payment information below.',
        CONTACT_INFORMATION: 'Contact Information',
        // mrs - consolidate - dup
        // PAYMENT_METHOD: 'Payment Method',
        FIRST_NAME: 'First Name',
        LAST_NAME: 'Last Name',
        BUSINESS_NAME: 'Business Name',
        EMAIL: 'Email Address',
        ORDER_REFERENCE_ID: 'Reference Number',
        PAYMENT_AMOUNT: 'Payment Amount',
        POLICY_NUMBER: 'Policy Number',
        INVOICE_NUMBER: 'Invoice Number',
        AMOUNT: 'Amount',
        PAYMENT_DESCRIPTION: 'Description',
        ORDER_SUMMARY: 'Order Summary',
        CURRENCY: 'Currency',
        // mrs - consolidate - dup
        // COPYRIGHT: 'Copyright',
        ERROR_GENERIC: 'Generic Error',
        ERROR_PAYMENT_ERROR: 'Payment Error',
        ERROR_ADYEN_CHECKOUT: 'Checkout Error',
        ERROR_ADYEN_NO_SESSION: 'No Adyen session error',
        // mrs - consolidate - dup
        // ERROR_FIRST_NAME_REQUIRED: 'First name is required',
        // ERROR_LAST_NAME_REQUIRED: 'Last name is required',
        // ERROR_EMAIL_REQUIRED: 'Email is required',
        // ERROR_EMAIL_INVALID: 'Email is invalid',
        PAYMENT_CANCELED: 'Your payment has been canceled.',
        RECEIVED_PAYMENT_OF: 'We have received your payment of',
        APPLIED_TO_ACCOUNT: 'that will be applied to your account.',
        NOT_CONFIRMATION: 'Receipt of payment is not confirmation that coverage is in effect, has been reinstated or will not be canceled. Coverage cannot be bound, changed or canceled without confirmation from an agency representative. Please contact your agent with any questions.',
        FURTHER_ASSISTANCE: 'If you need further assistance, please contact us at',
        USER_REQUESTED_ACCESS: 'A user has requested access to the Agency Payment Portal. Please use the link below to access the Agency Portal to allow access as desired.',
        USER_REQUESTED_ACCESS_SUBJECT: 'User Requested Access to the Agency Payment Portal',
        APPLIED_PAY_TEAM: 'The Applied Pay Team',
        ACCESS_APPROVED: 'Your access has been approved',
        THANK_YOU_AGAIN: 'Thank you again for your business!',
        PAYMENT_CONFIRMATION: 'Payment Confirmation',
        NUM_SIGN_TRANSACTIONS: '# of Transactions',
        CURRENT_MONTHLY_VOLUME: 'Current Monthly Volume (including convenience fees)',
        MONTHLY_VOLUME: 'Monthly Volume',
        MERCHANT_PROCESSING_FEES: 'Merchant Processing Fees',
        PROCESSING_FEES: 'Processing Fees',
        BRAND_NAME: 'Brand Name',
        LOGO: 'Logo',
        THEME: 'Theme',
        SAVE: 'Save',
        BRANDING_SUCCESS: 'Branding has successfully been updated for',
        BRANDING_FAILED: 'Branding has failed to update for',
        INVALID_FORM: 'invalid form',
        UPLOADING: 'Uploading...',
        CONVENIENCE_FEE: 'Convenience Fee',
        CONVENIENCE_FEE_AMOUNT: 'Convenience Fee Amount',
        CONVENIENCE_FEES: 'Convenience Fees',
        GROSS_DEPOSITS: 'Gross Deposits',
        CHARGEBACKS_COUNT: 'Chargebacks Count',
        CHARGEBACKS_AMOUNT: 'Chargebacks Amount',
        SELECT_MERCHANT_ACCOUNT: 'Select Merchant Account',
        DOWNLOAD_REPORT: 'Download Report',
        NO_TRANSACTIONS_AVAILABLE: 'No transactions available. Please update the search criteria.',
        PROCESSING_SUMMARY_FOR: 'Processing Summary for',
        DOWNLOAD_TAX_FORM: 'Download Tax Form',
    },
    [LocaleCode.en_CA]: {
        MERCHANT_ACCOUNT_REGISTRATION: 'Merchant Account Registration',
        FILL_OUT_FORM: 'Please fill out the form below.',
        // mrs - consolidate - dup
        // FIRST_NAME: 'First name',
        // LAST_NAME: 'Last name',
        ACCOUNT_NICKNAME: 'Account name',
        ACCOUNT_NICKNAME_TOOLTIP: 'This is to identify your account.',
        LEGAL_BUSINESS_NAME: 'Legal business name',
        LEGAL_ENTITY: 'Legal entity',
        PHONE: 'Phone number',
        // mrs - consolidate - dup
        // EMAIL: 'Email address',
        WEBSITE: 'Website',
        JOB_TITLE: 'Job title',
        SHAREHOLDER_TYPE: 'Shareholder Type',
        NEED_THE_FOLLOWING: 'To complete registration, you will need the following:',
        NEED_IMAGE_OF_ID: "Image of a government issued form of identification, such as your driver's licence or passport.",
        NEED_OWNER_INFO: 'SIN and Date of Birth of all individuals who directly or indirectly own 25% or more of the company.',
        START_WITH_BASIC_INFO: `Let's start with some basic information:`,
        PROCESSING_YOUR_APPLICATION: 'Processing your application...',
        MAY_TAKE_A_MINUTE: 'This may take up to a minute to complete.',
        SUCCESS: 'Success!',
        ONBOARDING_SUCCESS: 'Your application is complete and must be approved before you may begin processing. You may log in to the portal to check the status of your application.',
        BEING_REDIRECTED: 'Your application is complete and must be approved before you may begin processing. You may log in to the portal to check the status of your application.',
        GO_TO_LOGIN: 'Go to Portal',
        CANCEL: 'Cancel',
        CONTINUE: 'Continue',
        OK: 'OK',
        ERROR: 'Error',
        ERROR_REGISTERING: 'There was an error trying to register your account.',
        ERROR_UNKNOWN_TENANT: 'Unknown tenant',
        ERROR_FIRST_NAME_REQUIRED: 'First name is required',
        ERROR_LAST_NAME_REQUIRED: 'Last name is required',
        ERROR_PHONE_REQUIRED: 'Phone is required',
        ERROR_PHONE_INVALID: 'Phone is invalid',
        ERROR_URL_REQUIRED: 'Website is required',
        ERROR_URL_INVALID: 'Website is invalid',
        ERROR_EMAIL_REQUIRED: 'Email is required',
        ERROR_EMAIL_INVALID: 'Email is invalid',
        ERROR_NICKNAME_REQUIRED: 'Account nickname is required',
        ERROR_NICKNAME_INVALID: 'Account nickname is too long',
        ERROR_LEGAL_BUSINESS_NAME_REQUIRED: 'Legal business name is required',
        ERROR_LEGAL_ENTITY_REQUIRED: 'Legal entity is required',
        ERROR_SHAREHOLDER_REQUIRED: 'Shareholder is required',
        ERROR_JOB_TITLE_REQUIRED: 'Job title is required',
        ERROR_COUNTRY_CODE_REQUIRED: 'Country is required',
        ERROR_COUNTRY_CODE_INVALID: 'Country is invalid',
        ERROR_LOCALE_CODE_REQUIRED: 'Locale is required',
        ERROR_LOCALE_CODE_INVALID: 'Locale is invalid',
        ERROR_ACCOUNT_NUMBER_REQUIRED: 'Account number is required',
        ERROR_PHONE_NUMBER_REQUIRED: 'Phone number is required',
        ERROR_POSTAL_CODE_REQUIRED: 'Postal code is required',
        ERROR_NAME_REQUIRED: 'Name is required',
        TERMS_AND_CONDITIONS: 'Terms and Conditions',
        AGREE: 'I agree to the $t(TERMS_AND_CONDITIONS)',
        COPYRIGHT: 'Copyright',
        INDIVIDUAL: 'Individual',
        BUSINESS: 'Business',
        NON_PROFIT: 'Non-Profit',
        PARTNERSHIP: 'Partnership',
        PUBLIC_COMPANY: 'Public Company',
        OWNER: 'Owner',
        CONTROLLER: 'Controller',
        SIGNATORY: 'Signatory',
        THANK_YOU: 'Thank You!',
        ONBOARDING_RETURN_MESSAGE: 'You may log into the Portal to resume or check the status of your registration. You may begin processing when your merchant account has been approved.',
        NEED_BANK_INFO: 'Bank account information for settlement of funds. Federal Tax ID (EIN/TIN).',
        THANKS_FOR_SETTING_UP: 'Thank you for setting up a merchant account with AppliedPay.',
        BY_SIGNING_UP: 'By signing up for AppliedPay, you agree to the following:',
        AGREE_RATES: 'Processing rates of 3.5% for Credit Card Payments and $4.00 per EFT Transaction.',
        AGREE_NO_LIFE: 'You will not accept payments for Life Insurance Policies.',
        AGREE_LAW: 'Please follow all state, local and/or regulatory requirements for the handling of insurance payments and the appropriate trust accounting.',
        MUST_REQUEST_ACCESS: 'You are receiving this message because you have not been setup as a user to access the agency portal. Please fill out the form below to request access from your administrator.',
        REQUEST_ACCESS: 'Request Access',
        FAILED_TO_REQUEST_ACCESS: 'Failed to Request Access',
        ERROR_REQUESTING_ACCESS: "There was an error requesting access to the Portal. Perhaps you've already requested access.",
        YOU_WILL_BE_NOTIFIED_ONCE_APPROVED: 'You will be notified via email when your account has been approved.',
        COUNTRY: 'Country',
        LOCALE: 'Locale',
        LANGUAGE: 'Language',
        COUNTRY_UNITED_STATES: 'United States',
        COUNTRY_CANADA: 'Canada',
        COUNTRY_UNITED_KINGDOM: 'United Kingdom',
        LANGUAGE_ENGLISH: 'English',
        LANGUAGE_FRENCH: 'French',
        IMAGE_UPLOADED: 'Image has successfully been uploaded. Please save your changes.',
        IMAGE_UPLOAD_FAILED: 'Upload failed. Please verify required file types and file size',
        UPLOAD: 'Upload',
        FILE_SIZE_LIMIT: 'There is a file size limit of 2MB. File types accepted: png, bmp & jpg.',
        PRIMARY_COLOR: 'Primary Colour',
        PRIMARY_TEXT_COLOR: 'Primary Text Colour',
        ERROR_PRIMARY_COLOR_REQUIRED: 'Primary colour is required',
        ERROR_PRIMARY_TEXT_COLOR_REQUIRED: 'Primary text colour is required',
        PAYMENT_METHOD: 'Payment Method',
        TRANSACTIONS_COUNT: 'Transactions Count',
        TRANSACTIONS: 'Transactions',
        STATEMENTS: 'Statements',
        AGENCY_SETTINGS: 'Agency Settings',
        AGENCY_INFO_AND_BRANDING: 'Broker Information & Branding',
        LOADING: 'Loading',
        MAKE_A_PAYMENT: 'Make a Payment',
        ENTER_PAYMENT_INFO: 'Enter your payment information below.',
        CONTACT_INFORMATION: 'Contact Information',
        // mrs - consolidate - dup
        // PAYMENT_METHOD: 'Payment Method',
        FIRST_NAME: 'First Name',
        LAST_NAME: 'Last Name',
        BUSINESS_NAME: 'Business Name',
        EMAIL: 'Email Address',
        ORDER_REFERENCE_ID: 'Reference Number',
        PAYMENT_AMOUNT: 'Payment Amount',
        POLICY_NUMBER: 'Policy Number',
        INVOICE_NUMBER: 'Invoice Number',
        AMOUNT: 'Amount',
        PAYMENT_DESCRIPTION: 'Description',
        ORDER_SUMMARY: 'Order Summary',
        CURRENCY: 'Currency',
        // mrs - consolidate - dup
        // COPYRIGHT: 'Copyright',
        ERROR_GENERIC: 'Generic Error',
        ERROR_PAYMENT_ERROR: 'Payment Error',
        ERROR_ADYEN_CHECKOUT: 'Checkout Error',
        ERROR_ADYEN_NO_SESSION: 'No Adyen session error',
        // mrs - consolidate - dup
        // ERROR_FIRST_NAME_REQUIRED: 'First name is required',
        // ERROR_LAST_NAME_REQUIRED: 'Last name is required',
        // ERROR_EMAIL_REQUIRED: 'Email is required',
        // ERROR_EMAIL_INVALID: 'Email is invalid',
        PAYMENT_CANCELED: 'Your payment has been cancelled.',
        RECEIVED_PAYMENT_OF: 'We have received your payment of',
        APPLIED_TO_ACCOUNT: 'that will be applied to your account.',
        NOT_CONFIRMATION: 'Receipt of payment is not confirmation that coverage is in effect, has been reinstated or will not be canceled. Coverage cannot be bound, changed or canceled without confirmation from an agency representative. Please contact your agent with any questions.',
        FURTHER_ASSISTANCE: 'If you need further assistance, please contact us at',
        USER_REQUESTED_ACCESS: 'A user has requested access to the Agency Payment Portal. Please use the link below to access the Agency Portal to allow access as desired.',
        USER_REQUESTED_ACCESS_SUBJECT: 'User Requested Access to the Agency Payment Portal',
        APPLIED_PAY_TEAM: 'The Applied Pay Team',
        ACCESS_APPROVED: 'Your access has been approved',
        THANK_YOU_AGAIN: 'Thank you again for your business!',
        PAYMENT_CONFIRMATION: 'Payment Confirmation',
        NUM_SIGN_TRANSACTIONS: '# of Transactions',
        CURRENT_MONTHLY_VOLUME: 'Current Monthly Volume (including convenience fees)',
        MONTHLY_VOLUME: 'Monthly Volume',
        MERCHANT_PROCESSING_FEES: 'Merchant Processing Fees',
        PROCESSING_FEES: 'Processing Fees',
        BRAND_NAME: 'Brand Name',
        LOGO: 'Logo',
        THEME: 'Theme',
        SAVE: 'Save',
        BRANDING_SUCCESS: 'Branding has successfully been updated for',
        BRANDING_FAILED: 'Branding has failed to update for',
        INVALID_FORM: 'invalid form',
        UPLOADING: 'Uploading...',
        CONVENIENCE_FEE: 'Convenience Fee',
        CONVENIENCE_FEE_AMOUNT: 'Convenience Fee Amount',
        CONVENIENCE_FEES: 'Convenience Fees',
        GROSS_DEPOSITS: 'Gross Deposits',
        CHARGEBACKS_COUNT: 'Chargebacks Count',
        CHARGEBACKS_AMOUNT: 'Chargebacks Amount',
        SELECT_MERCHANT_ACCOUNT: 'Select Merchant Account',
        DOWNLOAD_REPORT: 'Download Report',
        NO_TRANSACTIONS_AVAILABLE: 'No transactions available. Please update the search criteria.',
        PROCESSING_SUMMARY_FOR: 'Processing Summary for',
        DOWNLOAD_TAX_FORM: 'Download Tax Form',
    },
    [LocaleCode.en_GB]: {
        MERCHANT_ACCOUNT_REGISTRATION: 'Merchant Account Registration',
        FILL_OUT_FORM: 'Please fill out the form below.',
        // mrs - consolidate - dup
        // FIRST_NAME: 'First name',
        // LAST_NAME: 'Last name',
        ACCOUNT_NICKNAME: 'Account name',
        ACCOUNT_NICKNAME_TOOLTIP: 'This is to identify your account.',
        LEGAL_BUSINESS_NAME: 'Legal business name',
        LEGAL_ENTITY: 'Legal entity',
        PHONE: 'Phone number',
        // mrs - consolidate - dup
        // EMAIL: 'Email address',
        WEBSITE: 'Website',
        JOB_TITLE: 'Job title',
        SHAREHOLDER_TYPE: 'Shareholder Type',
        NEED_THE_FOLLOWING: 'To complete registration, you will need the following:',
        NEED_IMAGE_OF_ID: "Image of a government issued form of identification, such as your driver's license or passport.",
        NEED_OWNER_INFO: 'SSN & Date of Birth of all individuals who directly or indirectly own 25% or more of the company.',
        START_WITH_BASIC_INFO: `Let's start with some basic information:`,
        PROCESSING_YOUR_APPLICATION: 'Processing your application...',
        MAY_TAKE_A_MINUTE: 'This may take up to a minute to complete.',
        SUCCESS: 'Success!',
        ONBOARDING_SUCCESS: 'You have successfully been onboarded.',
        BEING_REDIRECTED: 'You are being redirected...',
        GO_TO_LOGIN: 'Go to Portal',
        CANCEL: 'Cancel',
        CONTINUE: 'Continue',
        OK: 'Ok',
        ERROR: 'Error',
        ERROR_REGISTERING: 'There was an error trying to register your account.',
        ERROR_UNKNOWN_TENANT: 'Unknown tenant',
        ERROR_FIRST_NAME_REQUIRED: 'First name is required',
        ERROR_LAST_NAME_REQUIRED: 'Last name is required',
        ERROR_PHONE_REQUIRED: 'Phone is required',
        ERROR_PHONE_INVALID: 'Phone is invalid',
        ERROR_URL_REQUIRED: 'Website is required',
        ERROR_URL_INVALID: 'Website is invalid',
        ERROR_EMAIL_REQUIRED: 'Email is required',
        ERROR_EMAIL_INVALID: 'Email is invalid',
        ERROR_NICKNAME_REQUIRED: 'Account nickname is required',
        ERROR_NICKNAME_INVALID: 'Account nickname is too long',
        ERROR_LEGAL_BUSINESS_NAME_REQUIRED: 'Legal business name is required',
        ERROR_LEGAL_ENTITY_REQUIRED: 'Legal entity is required',
        ERROR_SHAREHOLDER_REQUIRED: 'Shareholder is required',
        ERROR_JOB_TITLE_REQUIRED: 'Job title is required',
        ERROR_COUNTRY_CODE_REQUIRED: 'Country is required',
        ERROR_COUNTRY_CODE_INVALID: 'Country is invalid',
        ERROR_LOCALE_CODE_REQUIRED: 'Locale is required',
        ERROR_LOCALE_CODE_INVALID: 'Locale is invalid',
        ERROR_ACCOUNT_NUMBER_REQUIRED: 'Account number is required',
        ERROR_PHONE_NUMBER_REQUIRED: 'Phone number is required',
        ERROR_POSTAL_CODE_REQUIRED: 'Postal code is required',
        ERROR_NAME_REQUIRED: 'Name is required',
        TERMS_AND_CONDITIONS: 'Terms and Conditions',
        AGREE: 'I agree to the $t(TERMS_AND_CONDITIONS)',
        COPYRIGHT: 'Copyright',
        INDIVIDUAL: 'Individual',
        BUSINESS: 'Business',
        NON_PROFIT: 'Non-Profit',
        PARTNERSHIP: 'Partnership',
        PUBLIC_COMPANY: 'Public Company',
        OWNER: 'Owner',
        CONTROLLER: 'Controller',
        SIGNATORY: 'Signatory',
        THANK_YOU: 'Thank You!',
        ONBOARDING_RETURN_MESSAGE: 'You may log into the Portal to resume or check the status of your registration. You may begin processing when your merchant account has been approved.',
        NEED_BANK_INFO: 'Bank account information for settlement of funds. Federal Tax ID (EIN/TIN).',
        THANKS_FOR_SETTING_UP: 'Thank you for setting up a merchant account with AppliedPay.',
        BY_SIGNING_UP: 'By signing up for AppliedPay, you agree to the following:',
        AGREE_RATES: 'Processing rates of 3.5% for Credit Card Payments and $4.00 per BACS/ACH Transaction.',
        AGREE_NO_LIFE: 'You will not accept payments for Life Insurance Policies.',
        AGREE_LAW: 'Please follow all state, local and/or regulatory requirements for the handling of insurance payments and the appropriate trust accounting.',
        MUST_REQUEST_ACCESS: 'You are receiving this message because you have not been setup as a user to access the agency portal. Please fill out the form below to request access from your administrator.',
        REQUEST_ACCESS: 'Request Access',
        FAILED_TO_REQUEST_ACCESS: 'Failed to Request Access',
        ERROR_REQUESTING_ACCESS: "There was an error requesting access to the Portal. Perhaps you've already requested access.",
        YOU_WILL_BE_NOTIFIED_ONCE_APPROVED: 'You will be notified via email when your account has been approved.',
        COUNTRY: 'Country',
        LOCALE: 'Locale',
        LANGUAGE: 'Language',
        COUNTRY_UNITED_STATES: 'United States',
        COUNTRY_CANADA: 'Canada',
        COUNTRY_UNITED_KINGDOM: 'United Kingdom',
        LANGUAGE_ENGLISH: 'English',
        LANGUAGE_FRENCH: 'French',
        IMAGE_UPLOADED: 'Image has successfully been uploaded. Please save your changes.',
        IMAGE_UPLOAD_FAILED: 'Upload failed. Please verify required file types and file size',
        UPLOAD: 'Upload',
        FILE_SIZE_LIMIT: 'There is a file size limit of 2MB. File types accepted: png, bmp & jpg.',
        PRIMARY_COLOR: 'Primary Colour',
        PRIMARY_TEXT_COLOR: 'Primary Text Colour',
        ERROR_PRIMARY_COLOR_REQUIRED: 'Primary colour is required',
        ERROR_PRIMARY_TEXT_COLOR_REQUIRED: 'Primary text color is required',
        PAYMENT_METHOD: 'Payment Method',
        TRANSACTIONS_COUNT: 'Transactions Count',
        TRANSACTIONS: 'Transactions',
        STATEMENTS: 'Statements',
        AGENCY_SETTINGS: 'Agency Settings',
        AGENCY_INFO_AND_BRANDING: 'Agency Information & Branding',
        LOADING: 'Loading',
        MAKE_A_PAYMENT: 'Make a Payment',
        ENTER_PAYMENT_INFO: 'Enter your payment information below.',
        CONTACT_INFORMATION: 'Contact Information',
        // mrs - consolidate - dup
        // PAYMENT_METHOD: 'Payment Method',
        FIRST_NAME: 'First Name',
        LAST_NAME: 'Last Name',
        BUSINESS_NAME: 'Business Name',
        EMAIL: 'Email Address',
        ORDER_REFERENCE_ID: 'Reference Number',
        PAYMENT_AMOUNT: 'Payment Amount',
        POLICY_NUMBER: 'Policy Number',
        INVOICE_NUMBER: 'Invoice Number',
        AMOUNT: 'Amount',
        PAYMENT_DESCRIPTION: 'Description',
        ORDER_SUMMARY: 'Order Summary',
        CURRENCY: 'Currency',
        // mrs - consolidate - dup
        // COPYRIGHT: 'Copyright',
        ERROR_GENERIC: 'Generic Error',
        ERROR_PAYMENT_ERROR: 'Payment Error',
        ERROR_ADYEN_CHECKOUT: 'Checkout Error',
        ERROR_ADYEN_NO_SESSION: 'No Adyen session error',
        // mrs - consolidate - dup
        // ERROR_FIRST_NAME_REQUIRED: 'First name is required',
        // ERROR_LAST_NAME_REQUIRED: 'Last name is required',
        // ERROR_EMAIL_REQUIRED: 'Email is required',
        // ERROR_EMAIL_INVALID: 'Email is invalid',
        PAYMENT_CANCELED: 'Your payment has been cancelled.',
        RECEIVED_PAYMENT_OF: 'We have received your payment of',
        APPLIED_TO_ACCOUNT: 'that will be applied to your account.',
        NOT_CONFIRMATION: 'Receipt of payment is not confirmation that coverage is in effect, has been reinstated or will not be canceled. Coverage cannot be bound, changed or canceled without confirmation from an agency representative. Please contact your agent with any questions.',
        FURTHER_ASSISTANCE: 'If you need further assistance, please contact us at',
        USER_REQUESTED_ACCESS: 'A user has requested access to the Agency Payment Portal. Please use the link below to access the Agency Portal to allow access as desired.',
        USER_REQUESTED_ACCESS_SUBJECT: 'User Requested Access to the Agency Payment Portal',
        APPLIED_PAY_TEAM: 'The Applied Pay Team',
        ACCESS_APPROVED: 'Your access has been approved',
        THANK_YOU_AGAIN: 'Thank you again for your business!',
        PAYMENT_CONFIRMATION: 'Payment Confirmation',
        NUM_SIGN_TRANSACTIONS: '# of Transactions',
        CURRENT_MONTHLY_VOLUME: 'Current Monthly Volume (including convenience fees)',
        MONTHLY_VOLUME: 'Monthly Volume',
        MERCHANT_PROCESSING_FEES: 'Merchant Processing Fees',
        PROCESSING_FEES: 'Processing Fees',
        BRAND_NAME: 'Brand Name',
        LOGO: 'Logo',
        THEME: 'Theme',
        SAVE: 'Save',
        BRANDING_SUCCESS: 'Branding has successfully been updated for',
        BRANDING_FAILED: 'Branding has failed to update for',
        INVALID_FORM: 'invalid form',
        UPLOADING: 'Uploading...',
        CONVENIENCE_FEE: 'Convenience Fee',
        CONVENIENCE_FEE_AMOUNT: 'Convenience Fee Amount',
        CONVENIENCE_FEES: 'Convenience Fees',
        GROSS_DEPOSITS: 'Gross Deposits',
        CHARGEBACKS_COUNT: 'Chargebacks Count',
        CHARGEBACKS_AMOUNT: 'Chargebacks Amount',
        SELECT_MERCHANT_ACCOUNT: 'Select Merchant Account',
        DOWNLOAD_REPORT: 'Download Report',
        NO_TRANSACTIONS_AVAILABLE: 'No transactions available. Please update the search criteria.',
        PROCESSING_SUMMARY_FOR: 'Processing Summary for',
        DOWNLOAD_TAX_FORM: 'Download Tax Form',
    },
    [LocaleCode.fr_CA]: {
        MERCHANT_ACCOUNT_REGISTRATION: 'Enregistrement de compte marchand',
        FILL_OUT_FORM: 'Remplissez le formulaire ci-dessous.',
        FIRST_NAME: 'Prénom',
        LAST_NAME: 'Nom',
        ACCOUNT_NICKNAME: 'Pseudo du compte',
        ACCOUNT_NICKNAME_TOOLTIP: 'C’est pour identifier votre compte.',
        LEGAL_BUSINESS_NAME: 'Nom légal de l’entreprise',
        LEGAL_ENTITY: 'Entité légale',
        PHONE: 'Numéro de téléphone',
        EMAIL: 'Courriel',
        WEBSITE: 'Site Web',
        JOB_TITLE: 'Titre de poste',
        SHAREHOLDER_TYPE: 'Type d’actionnaire',
        NEED_THE_FOLLOWING: 'Pour terminer l’inscription, vous aurez besoin des éléments suivants :',
        NEED_IMAGE_OF_ID: 'Image d’une pièce d’identité émise par le gouvernement, telle que votre permis de conduire ou votre passeport.',
        NEED_OWNER_INFO: 'NAS et date de naissance de toutes les personnes qui détiennent directement ou indirectement 25 % ou plus de l’entreprise.',
        START_WITH_BASIC_INFO: `Commençons par quelques renseignements de base :`,
        PROCESSING_YOUR_APPLICATION: 'Traitement de votre demande...',
        MAY_TAKE_A_MINUTE: 'Cela peut prendre jusqu’à une minute.',
        SUCCESS: 'Succès!',
        ONBOARDING_SUCCESS: 'Votre demande est remplie et doit être approuvée avant que vous puissiez commencer le traitement. Vous pouvez vous connecter au portail pour vérifier l’état de votre demande.',
        BEING_REDIRECTED: 'Votre demande est remplie et doit être approuvée avant que vous puissiez commencer le traitement. Vous pouvez vous connecter au portail pour vérifier l’état de votre demande.',
        GO_TO_LOGIN: 'Aller au portail',
        CANCEL: 'Annuler',
        CONTINUE: 'Continuer',
        OK: 'OK',
        ERROR: 'Erreur',
        ERROR_REGISTERING: 'Une erreur s’est produite lors de la tentative d’inscription de votre compte.',
        ERROR_UNKNOWN_TENANT: 'Locataire inconnu',
        ERROR_FIRST_NAME_REQUIRED: 'Le prénom est requis',
        ERROR_LAST_NAME_REQUIRED: 'Le nom est requis',
        ERROR_PHONE_REQUIRED: 'Le numéro de téléphone est requis',
        ERROR_PHONE_INVALID: 'Le numéro de téléphone est non valide',
        ERROR_URL_REQUIRED: 'Le site Web est requis',
        ERROR_URL_INVALID: 'Le site Web est non valide',
        ERROR_EMAIL_REQUIRED: 'Le courriel est requis',
        ERROR_EMAIL_INVALID: 'Le courriel est non valide',
        ERROR_NICKNAME_REQUIRED: 'Le pseudo du compte est requis',
        ERROR_NICKNAME_INVALID: 'Le pseudo du compte est trop long',
        ERROR_LEGAL_BUSINESS_NAME_REQUIRED: 'Le nom légal de l’entreprise est requis',
        ERROR_LEGAL_ENTITY_REQUIRED: 'L’entité légale est requise',
        ERROR_SHAREHOLDER_REQUIRED: 'L’actionnaire est requis',
        ERROR_JOB_TITLE_REQUIRED: 'Le titre de poste est requis',
        ERROR_COUNTRY_CODE_REQUIRED: 'Le pays est requis',
        ERROR_COUNTRY_CODE_INVALID: 'Le pays est non valide',
        ERROR_LOCALE_CODE_REQUIRED: 'L’emplacement est requis',
        ERROR_LOCALE_CODE_INVALID: 'L’emplacement est non valide',
        ERROR_ACCOUNT_NUMBER_REQUIRED: 'Le numéro de compte est requis',
        ERROR_PHONE_NUMBER_REQUIRED: 'Le numéro de téléphone est requis',
        ERROR_POSTAL_CODE_REQUIRED: 'Le code postal est requis',
        ERROR_NAME_REQUIRED: 'Nom requis',
        TERMS_AND_CONDITIONS: "Conditions d'utilisation générales",
        // Conditions d'utilisation générales
        // J’accepte les conditions générales
        AGREE: 'J’accepte les $t(TERMS_AND_CONDITIONS)',
        COPYRIGHT: 'Tous droits réservés',
        INDIVIDUAL: 'Particulier',
        BUSINESS: 'Entreprise',
        NON_PROFIT: 'À but non lucratif',
        PARTNERSHIP: 'Partenariat',
        PUBLIC_COMPANY: 'Entreprise publique',
        OWNER: 'Propriétaire',
        CONTROLLER: 'Contrôleur',
        SIGNATORY: 'Signataire',
        THANK_YOU: 'Merci!',
        ONBOARDING_RETURN_MESSAGE: 'Vous pouvez vous connecter au portail pour poursuivre ou pour vérifier l’état de votre inscription. Vous pouvez commencer le traitement après l’approbation de votre compte marchand.',
        NEED_BANK_INFO: 'Informations relatives au compte bancaire pour le règlement des fonds. ID taxe fédérale (EIN/TIN).',
        THANKS_FOR_SETTING_UP: 'Merci d’avoir créé un compte marchand avec AppliedPay.',
        BY_SIGNING_UP: 'En vous inscrivant à AppliedPay, vous acceptez ce qui suit:',
        AGREE_RATES: 'Taux de traitement de 3,5 % pour les paiements par carte de crédit et 4 $ par transaction FNB.',
        AGREE_NO_LIFE: 'Vous n’accepterez pas les paiements pour les polices d’assurance-vie.',
        AGREE_LAW: 'Veuillez suivre toutes les exigences nationales, locales et/ou réglementaires pour le traitement des paiements d’assurance et la comptabilité fiduciaire appropriée.',
        MUST_REQUEST_ACCESS: 'Vous recevez ce message car vous n’avez pas été configuré en tant qu’utilisateur pour accéder au portail du cabinet. Veuillez remplir le formulaire ci-dessous pour demander l’accès à votre administrateur.',
        REQUEST_ACCESS: 'Demander un accès',
        FAILED_TO_REQUEST_ACCESS: 'Échec de la demande d’accès',
        ERROR_REQUESTING_ACCESS: 'Une erreur s’est produite lors de la demande d’accès au portail. Vous avez peut-être déjà demandé l’accès.',
        YOU_WILL_BE_NOTIFIED_ONCE_APPROVED: 'Vous serez averti par courriel lorsque votre compte aura été approuvé.',
        COUNTRY: 'Pays',
        LOCALE: 'Région',
        LANGUAGE: 'Langue',
        COUNTRY_UNITED_STATES: 'États-Unis',
        COUNTRY_CANADA: 'Canada',
        COUNTRY_UNITED_KINGDOM: 'Royaume-Uni',
        LANGUAGE_ENGLISH: 'Anglais',
        LANGUAGE_FRENCH: 'Français',
        IMAGE_UPLOADED: 'L’image a été téléchargée avec succès. Veuillez enregistrer vos modifications.',
        IMAGE_UPLOAD_FAILED: 'Échec du téléchargement. Veuillez vérifier les types de fichiers requis et la taille des fichiers.',
        UPLOAD: 'Charger',
        FILE_SIZE_LIMIT: 'La limite de taille pour les fichiers est de 2 Mo. Types de fichiers acceptés : png, bmp et jpg.',
        PRIMARY_COLOR: 'Couleur principale',
        PRIMARY_TEXT_COLOR: 'Colour du texte principale',
        ERROR_PRIMARY_COLOR_REQUIRED: 'La couleur principale est requise',
        ERROR_PRIMARY_TEXT_COLOR_REQUIRED: 'La couleur du texte principal est requise',
        PAYMENT_METHOD: 'Mode de paiement',
        TRANSACTIONS_COUNT: 'Nombre de transactions',
        TRANSACTIONS: 'Transactions',
        STATEMENTS: 'Relevés',
        AGENCY_SETTINGS: 'Paramètres du cabinet',
        AGENCY_INFO_AND_BRANDING: 'Informations et image du cabinet',
        LOADING: 'Chargement',
        MAKE_A_PAYMENT: 'Effectuer un paiement',
        ENTER_PAYMENT_INFO: 'Saisissez vos informations de paiement ci-dessous.',
        CONTACT_INFORMATION: 'Coordonnées',
        // mrs - consolidate - dup
        // PAYMENT_METHOD: 'Mode de paiement',
        // FIRST_NAME: 'Prénom',
        // LAST_NAME: 'Nom',
        BUSINESS_NAME: 'Nom d’entreprise',
        // mrs - consolidate - dup
        // EMAIL: 'Courriel',
        ORDER_REFERENCE_ID: 'Numéro de référence',
        PAYMENT_AMOUNT: 'Montant du paiement',
        POLICY_NUMBER: 'Numéro de la police',
        INVOICE_NUMBER: 'Numéro de facture',
        AMOUNT: 'Montant',
        PAYMENT_DESCRIPTION: 'Descriptions',
        ORDER_SUMMARY: 'Sommaire de la commande',
        CURRENCY: 'Devise',
        // mrs - consolidate - dup
        // COPYRIGHT: 'Tous droits réservés',
        ERROR_GENERIC: 'Erreur générique',
        ERROR_PAYMENT_ERROR: 'Erreur de paiement',
        ERROR_ADYEN_CHECKOUT: 'Erreur lors du passage à la caisse',
        ERROR_ADYEN_NO_SESSION: 'Pas d’erreur de session Adyen',
        // mrs - consolidate - dup
        // ERROR_FIRST_NAME_REQUIRED: 'Le prénom est requis',
        // ERROR_LAST_NAME_REQUIRED: 'Le nom est requis',
        // ERROR_EMAIL_REQUIRED: 'Le courriel est requis',
        // ERROR_EMAIL_INVALID: 'Le courriel est non valide',
        PAYMENT_CANCELED: 'Your payment has been cancelled.',
        RECEIVED_PAYMENT_OF: 'We have received your payment of',
        APPLIED_TO_ACCOUNT: 'that will be applied to your account.',
        NOT_CONFIRMATION: 'Receipt of payment is not confirmation that coverage is in effect, has been reinstated or will not be canceled. Coverage cannot be bound, changed or canceled without confirmation from an agency representative. Please contact your agent with any questions.',
        FURTHER_ASSISTANCE: 'If you need further assistance, please contact us at',
        USER_REQUESTED_ACCESS: 'Un utilisateur a demandé l’accès au Portail de Paiement de l’Agence. Veuillez utiliser le lien ci-dessous pour accéder au Portail de Paiement pour autoriser l’accès comme demandé.',
        USER_REQUESTED_ACCESS_SUBJECT: 'L’utilisateur a demandé l’accès au portail de paiement de l’agence',
        APPLIED_PAY_TEAM: 'L’équipe Applied Pay',
        ACCESS_APPROVED: 'Votre accès a été approuvé',
        THANK_YOU_AGAIN: 'Nous vous remercions encore une fois de votre confiance!',
        PAYMENT_CONFIRMATION: 'Payment Confirmation',
        NUM_SIGN_TRANSACTIONS: '# of Transactions',
        CURRENT_MONTHLY_VOLUME: 'Current Monthly Volume (including convenience fees)',
        MONTHLY_VOLUME: 'Volume mensuel',
        MERCHANT_PROCESSING_FEES: 'Merchant Processing Fees',
        PROCESSING_FEES: 'Frais de traitement',
        BRAND_NAME: 'Nom de la marque',
        LOGO: 'Logo',
        THEME: 'Thème',
        SAVE: 'Enregistrer',
        BRANDING_SUCCESS: 'La marque a été mise à jour avec succès pour',
        BRANDING_FAILED: 'Échec de la mise à jour de la marque pour',
        INVALID_FORM: 'formulaire non valide',
        UPLOADING: 'Téléchargement en cours...',
        CONVENIENCE_FEE: 'Frais de commodité',
        CONVENIENCE_FEE_AMOUNT: 'Montant frais de commodité',
        CONVENIENCE_FEES: 'Frais de commodité',
        GROSS_DEPOSITS: 'Dépôts bruts',
        CHARGEBACKS_COUNT: 'Nombre de rétrofacturations',
        CHARGEBACKS_AMOUNT: 'Montant des rétrofacturations',
        SELECT_MERCHANT_ACCOUNT: 'Sélectionner un compte marchand',
        DOWNLOAD_REPORT: 'Télécharger le rapport',
        NO_TRANSACTIONS_AVAILABLE: 'Aucune transaction disponible. Veuillez mettre à jour les critères de recherche.',
        PROCESSING_SUMMARY_FOR: 'Résumé du traitement pour',
        DOWNLOAD_TAX_FORM: 'Télécharger le formulaire fiscal',
    },
};
//# sourceMappingURL=translations.js.map